// Cancelar um produto que JÁ FOI ENTREGUE (dono, 03/10/2026 — Mesa 4 da Mestre
// dos Jogos). A cliente tinha 2 sucos entregues e pediu mais 2; quiseram tirar
// um dos novos e a lixeira tocada foi a da linha "2×" antiga. O produto saiu
// da conta, a cozinha não foi avisada (o pedido dele já tinha saído de lá) e
// fez os dois. A janela agora diz que aquele já foi entregue e, se o mesmo
// produto ainda não chegou na mesa em outra linha, oferece cancelar esse.
// Quem decide é a pessoa: nada troca sozinho.

const nomeDe = (i) => String(i?.name || i?.nome || "").trim().toLowerCase();
const produtoDe = (i) => String(i?.product_id || i?.id || "");

/** "22:29" de um instante ISO, ou "". */
export function horaDe(iso) {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "";
}

/** Quando a linha foi pedida: rodada do QR (`_at`) ou envio do garçom (`_envio`). */
export function pedidoEm(item) {
  return item?._at || item?._envio || item?.envio || null;
}

const ROTULO = { producao: "em produção", pronto: "pronto, esperando o garçom" };

/** Linhas do MESMO produto que ainda não chegaram na mesa (em produção ou
 *  prontas), na ordem da comanda. `situacaoDe(item, itens)` é a do
 *  `useSituacaoItensMesa`: sem situação conhecida a linha fica de fora. */
export function iguaisNaCozinha(itens, idx, situacaoDe) {
  const lista = itens || [];
  const alvo = lista[idx];
  if (!alvo) return [];
  const saida = [];
  lista.forEach((item, i) => {
    if (i === idx || !item || item.deleted) return;
    if (produtoDe(item) !== produtoDe(alvo) || nomeDe(item) !== nomeDe(alvo)) return;
    const rotulo = ROTULO[situacaoDe(item, lista)?.situacao];
    if (!rotulo) return;
    saida.push({
      idx: i,
      item,
      rotulo,
      pedidoAs: horaDe(pedidoEm(item)),
      quem: item._cliente_nome || item._por || "",
      observacao: String(item.observation || item.observacao || "").trim(),
    });
  });
  return saida;
}

/** O que a janela de cancelar precisa saber da linha `idx`:
 *  `{ entregue, entregueAs, iguais }`. Só linha entregue ganha `iguais`. */
export function contextoDoCancelamento(itens, idx, situacaoDe) {
  const alvo = (itens || [])[idx];
  const sit = alvo && !alvo.deleted ? situacaoDe(alvo, itens) : null;
  const entregue = sit?.situacao === "entregue";
  return {
    entregue,
    entregueAs: entregue ? horaDe(sit.entregue_at) : "",
    iguais: entregue ? iguaisNaCozinha(itens, idx, situacaoDe) : [],
  };
}
